// extracted by mini-css-extract-plugin
export default {"RouteTabs":"RouteTabs_RouteTabs__5R5tS"};